/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Alert } from '@material-ui/lab';
import { FormattedMessage } from 'react-intl';
import error, { errorProps } from 'aurora-utils/error';
import { keyEmptyCheck } from 'aurora-utils/utils';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import { ADGMSnackbar, CancelApplicationModal, ADGMImage } from 'aurora-components';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import isObject from 'lodash/isObject';
import messages from 'aurora-translations';
import isEmpty from 'lodash/isEmpty';
import AutoCancellationBar from 'aurora-section-components/AutoCancellationBar';
import styles from './styleJss';

function Header(props) {
  const {
    classes,
    failure,
    commonError,
    application,
    feedbackNoteTitle,
    downloadCertificatesList,
    handleSubmitCancelApplication,
    customApplicationStatus,
    downloadReceipt,
    applicationId,
    customTitle,
    customSubTitle,
    showNote,
    headerWithoutActions,
  } = props;

  const cancelHandler = () => {
    handleSubmitCancelApplication(applicationId);
  };
  const [isModalOpenApplicationReject, setModalOpenApplicationReject] = useState(false);
  const [isDownloadMenuOpen, setDownloadMenuOpen] = useState(null);
  const handleClose = () => {
    setDownloadMenuOpen(null);
  };
  const toggleModalApplicationReject = () => {
    setModalOpenApplicationReject(!isModalOpenApplicationReject);
  };

  const SHOW_CANCEL_APPLICATION_BUTTON =
    application?.applicationDetails?.initiator === true &&
    application?.applicationDetails?.canCancel === true &&
    typeof handleSubmitCancelApplication === 'function';

  return (
    <>
      {failure?.statusCode && (
        <Alert severity='error' className={classes.errorMessage}>
          {keyEmptyCheck(failure?.message)}
        </Alert>
      )}
      {showNote &&
      ['ADGM_RETURN', 'ADGM_REJECT', 'REJECTED', 'RETURNED'].includes(
        application?.applicationDetails?.applicationStatus,
      ) &&
      !isEmpty(application?.applicationDetails?.rejectionReason?.notes) ? (
        <div className={classes.FeedbackRejectionHolderOwner}>
          <Typography variant='subtitle1'>{keyEmptyCheck(feedbackNoteTitle)}</Typography>

          <Typography variant='body1'>
            <ul>
              <li>{application?.applicationDetails?.rejectionReason?.notes}</li>
            </ul>
          </Typography>
        </div>
      ) : (
        ''
      )}
      <Grid container spacing={2} className={classes.initiateserviceSect}>
        <Grid item xs={12} md={headerWithoutActions ? 12 : 9}>
          <Grid container>
            {application?.applicationDetails?.applicationType === 'PMA_REGISTRATION' ? (
              <Grid item xs={12} md={9} className={classes.headerV2}>
                <div>
                  <ADGMImage
                    name='Company_avatar.svg'
                    alt='company'
                    className={classes.headerLogo}
                    aria-hidden='true'
                  />
                </div>
                <div className={classes.headerContentV2}>
                  <Typography variant='h6' component='h1' className={classes.TitleV2}>
                    {keyEmptyCheck(application?.applicationDetails?.applicationType)}
                  </Typography>
                  <Typography variant='body1' className={classes.subTitle}>
                    {application?.applicationDetails?.applicationNumber}
                  </Typography>
                </div>
              </Grid>
            ) : (
              <Grid item xs={12} md={9}>
                <div className={classes.textHolder}>
                  <Typography variant='h5' component='h1' className={classes.Title}>
                    {customTitle ?? keyEmptyCheck(application?.applicationDetails?.applicationType)}
                  </Typography>
                  <Typography variant='body1' className={classes.headsubtitle}>
                    {customSubTitle ?? application?.applicationDetails?.applicationNumber}
                  </Typography>
                  <Grid className={classes.initiatedByDiscription}>
                    {/* <div className={classes.initiatedByHolder}>
                      <ADGMImage name='ProfileIcon.svg' alt="ProfileIcon" />
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.actioner}
                      >
                        <FormattedMessage
                          {...messages.initiated_by}
                          values={{
                          s: `${
                            locale === "en"
                              ? application?.applicationDetails
                                  ?.initiatorName ||
                                application?.applicationDetails?.initiatorNameAr
                              : application?.applicationDetails
                                  ?.initiatorNameAr ||
                                application?.applicationDetails?.initiatorName
                          }`,
                        }}
                        />
                      </Typography>
                    </div> */}
                    <div className={classes.applicationStatus}>
                      <div
                        className={classNames({
                          [classes.draftsBadge]: application?.applicationDetails?.progressStatus === 'DRAFT',
                          [classes.inProgBadge]: application?.applicationDetails?.progressStatus === 'IN_PROGRESS',
                          [classes.completedBadge]: application?.applicationDetails?.progressStatus === 'COMPLETED',
                          [classes.rejectedBadge]: application?.applicationDetails?.progressStatus === 'REJECTED',
                          [classes.cancelledBadge]: application?.applicationDetails?.progressStatus === 'CANCELLED',
                        })}
                      >
                        <svg width='4' height='4' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <circle cx='4' cy='4' r='4' fill='#008558' />
                        </svg>
                      </div>

                      <Typography
                        variant='body1'
                        component='p'
                        className={classNames(
                          // classes.warrningMessage,
                          classes.noWrap,
                          classes.status,
                        )}
                      >
                        {customApplicationStatus || keyEmptyCheck(application?.applicationDetails?.applicationStatus)}
                      </Typography>
                      <Typography
                        variant='body1'
                        component='p'
                        className={classNames(
                          // classes.warrningMessage,
                          classes.noWrap,
                          classes.noWrap,
                          classes.status,
                        )}
                      >
                        ({keyEmptyCheck(application?.applicationDetails?.progressStatus)})
                      </Typography>

                      {/* <ADGMImage name='badge.svg' className={classNames(classes.pendingLabel, {
                      [classes.draftsLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "DRAFT",
                      [classes.inProgBadge]:
                        application?.applicationDetails?.progressStatus ===
                        "IN_PROGRESS",
                      [classes.completedLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "COMPLETED",
                      [classes.rejectedLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "REJECTED",
                      [classes.cancelledLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "CANCELLED",
                    })} alt="bagdgeIcon" /> */}
                    </div>
                    |
                    <div className={classes.initiatedByHolder}>
                      {/* <ADGMImage name='clockIcon.svg' alt="clockIcon" /> */}
                      <Typography variant='body1' component='p' className={classes.actioner}>
                        {application?.applicationDetails?.submittedDate && (
                          <FormattedMessage
                            {...messages.Submitted}
                            values={{
                              s: `${moment(application?.applicationDetails?.submittedDate).format('DD/MM/YYYY')}`,
                            }}
                          />
                        )}
                      </Typography>
                    </div>
                  </Grid>
                </div>
              </Grid>
            )}
            {/* <Grid item xs={12} md={3}>
              <div className={classes.mainBtnholdaer}>
                <div className={classes.chipHolder}>
                  <Chip
                    label={keyEmptyCheck(
                      application?.applicationDetails?.progressStatus
                    )}
                    className={classNames(classes.pendingLabel, {
                      [classes.draftsLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "DRAFT",
                      [classes.inProgLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "IN_PROGRESS",
                      [classes.completedLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "COMPLETED",
                      [classes.rejectedLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "REJECTED",
                      [classes.cancelledLabelBG]:
                        application?.applicationDetails?.progressStatus ===
                        "CANCELLED",
                    })}
                  />
                  <Typography
                    variant="body1"
                    component="p"
                    className={classNames(
                      classes.warrningMessage,
                      classes.noWrap,
                      {
                        [classes.draftsMessageBG]:
                          application?.applicationDetails?.applicationStatus ===
                          "DRAFT",
                        [classes.inProgMessageBG]:
                          application?.applicationDetails?.applicationStatus ===
                          "BUYER_APPROVAL",
                        [classes.completedMessageBG]:
                          application?.applicationDetails?.applicationStatus ===
                          "COMPLETED",
                        [classes.dmtReviewMessageBG]:
                          application?.applicationDetails?.applicationStatus ===
                          "DMT_REVIEW",
                        [classes.RETURNEDMessageBG]:
                          application?.applicationDetails?.applicationStatus ===
                          "RETURNED",
                        [classes.rejectedMessageBG]:
                          application?.applicationDetails?.applicationStatus ===
                          "REJECTED",
                        [classes.cancelledMessageBG]:
                          application?.applicationDetails?.applicationStatus ===
                          "CANCELLED",
                      }
                    )}
                  >
                    <InfoRoundedIcon />
                    {customApplicationStatus ||
                      keyEmptyCheck(
                        application?.applicationDetails?.applicationStatus
                      )}
                  </Typography>
                </div>
              </div>
            </Grid> */}
          </Grid>
        </Grid>
        {!headerWithoutActions && (
          <>
            <Grid item xs={12} md={3}>
              <div className={classes.mainBtnholdaer}>
                <div className={classes.btnHolder}>
                  {/* {isArray(downloadCertificatesList) && (
                    <Grid container spacing={1}>
                      {downloadCertificatesList?.map((certificate) => (
                        <>
                          <Grid item xs={12}>
                            <Button
                              variant="outlined"
                              color="primary"
                              className={[
                                certificate?.primary && classes.primary,
                                classes.downloadBtnoutline,
                              ]}
                              onClick={certificate?.downloadHandler}
                            >
                              <ADGMImage
                                name={
                                  certificate?.icon
                                    ? certificate.icon
                                    : certificate?.primary
                                    ? "Download-contract-white.svg"
                                    : "Download-contract-black.svg"
                                }
                                alt="RoundedPDFIcon"
                              />{" "}
                              {keyEmptyCheck(certificate?.title)}
                            </Button>
                          </Grid>
                        </>
                      ))}
                    </Grid>
                  )} */}
                  {/* {typeof downloadReceipt === "function" && (
                    <Button
                      variant="outlined"
                      color="primary"
                      className={classNames(
                        classes.downloadBtnoutline,
                        classes.paymentReceiptDownloadBtn
                      )}
                      onClick={downloadReceipt}
                    >
                      <ADGMImage
                        name="Download-contract-black.svg"
                        alt="DownloadReceiptIcon"
                      />{" "}
                      {keyEmptyCheck("download_receipt")}
                    </Button>
                  )} */}
                  {(downloadCertificatesList?.length || typeof downloadReceipt === 'function') && (
                    <>
                      <Button
                        className={classes.dropDownDownloadBtn}
                        aria-controls='download-menu'
                        aria-haspopup='true'
                        onClick={e => setDownloadMenuOpen(e.currentTarget)}
                      >
                        <span>{keyEmptyCheck('download')}</span>
                        <ADGMImage
                          name={isDownloadMenuOpen ? 'arrow-up-white.svg' : 'arrow-down-white.svg'}
                          alt='arrow down'
                        />
                      </Button>
                      <Menu
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        id='download-menu'
                        anchorEl={isDownloadMenuOpen}
                        open={Boolean(isDownloadMenuOpen)}
                        onClose={() => setDownloadMenuOpen(null)}
                        getContentAnchorEl={null}
                        classes={{
                          paper: classes.navMenuDropdown,
                          list: classes.menuList,
                        }}
                        PaperProps={{
                          style: {
                            borderRadius: '0px',
                          },
                        }}
                      >
                        {[...(downloadCertificatesList || [])].map(doc => (
                          <MenuItem
                            key={doc.title}
                            onClick={() => {
                              doc?.downloadHandler();
                              handleClose();
                            }}
                          >
                            <ADGMImage name='Download-Icon.svg' alt='Icon' />
                            {keyEmptyCheck(doc.title)}
                          </MenuItem>
                        ))}
                        {/* {paymentReceipts?.length > 1 && (
                    <MenuItem
                      onClick={() => {
                        // Execute all download handlers
                        Promise.all(paymentReceipts?.map(receipt => receipt?.downloadHandler()));
                        handleClose();
                      }}
                    >
                      <ADGMImage name='Download-Icon.svg' alt='Icon' />
                      {keyEmptyCheck('download_both_receipts')}
                    </MenuItem>
                  )} */}
                      </Menu>
                    </>
                  )}
                  {SHOW_CANCEL_APPLICATION_BUTTON && (
                    <Button
                      variant='outlined'
                      color='primary'
                      className={classes.downloadBtnoutline}
                      onClick={toggleModalApplicationReject}
                    >
                      <CancelOutlinedIcon /> <FormattedMessage {...messages.cancel_application} />
                    </Button>
                  )}
                </div>
              </div>
            </Grid>

            <CancelApplicationModal
              open={isModalOpenApplicationReject}
              onClose={toggleModalApplicationReject}
              toggleModal={toggleModalApplicationReject}
              cancelApplication={cancelHandler}
            />
          </>
        )}

        {application?.applicationDetails?.autoCancellationReason && (
          <Grid item xs={12}>
            <AutoCancellationBar />
          </Grid>
        )}
      </Grid>

      {isObject(commonError) && (
        <ADGMSnackbar
          message={
            isObject(keyEmptyCheck(commonError?.message)) ? keyEmptyCheck(commonError?.message) : commonError?.message
          }
        />
      )}
    </>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string,
  handleSubmitCancelApplication: PropTypes.func.isRequired,
  application: PropTypes.object.isRequired,
  failure: errorProps,
  commonError: errorProps,
  downloadCertificatesList: PropTypes.array,
  customApplicationStatus: PropTypes.node,
  downloadReceipt: PropTypes.func.isOptional,
  applicationId: PropTypes.string.isRequired,
  customTitle: PropTypes.any,
  customSubTitle: PropTypes.any,
  showNote: PropTypes.bool,
  feedbackNoteTitle: PropTypes.string,
  headerWithoutActions: PropTypes.bool,
};
Header.defaultProps = {
  failure: error,
  commonError: null,
  locale: 'en',
  downloadCertificatesList: [],
  customApplicationStatus: null,
  downloadReceipt: null,
  customTitle: null,
  customSubTitle: null,
  showNote: true,
  feedbackNoteTitle: 'feedback_text',
  headerWithoutActions: false,
};
export default withStyles(styles)(Header);
